<template>
  <div class="container">
    <div class="footer-container">
      <img
        class="separator-img w-100"
        src="~/assets/imgs/Separator.png"
        alt="Separator"
      />
      <div class="main-links-container">
        <div class="d-flex gap-5">
          <div class="image-container">
            <nuxt-link :to="localePath('/')">
              <img
                v-if="locale == 'ar'"
                src="~/assets/imgs/mainLogo-rtl.svg"
                alt="khalej"
              />
              <img
                v-if="locale == 'en'"
                src="~/assets/imgs/mainLogo-ltr.svg"
                alt="khalej"
              />
            </nuxt-link>
            <p>{{ $t("foot1") }}</p>
            <div v-if="store.social" class="icons">
              <a
                aria-label="instagram"
                :href="store.social?.instagram"
                v-if="store.social?.instagram"
                target="_blank"
                class="icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_158_2761)">
                    <path
                      d="M10 1.80078C12.6719 1.80078 12.9883 1.8125 14.0391 1.85937C15.0156 1.90234 15.543 2.06641 15.8945 2.20313C16.3594 2.38281 16.6953 2.60156 17.043 2.94922C17.3945 3.30078 17.6094 3.63281 17.7891 4.09766C17.9258 4.44922 18.0898 4.98047 18.1328 5.95312C18.1797 7.00781 18.1914 7.32422 18.1914 9.99219C18.1914 12.6641 18.1797 12.9805 18.1328 14.0313C18.0898 15.0078 17.9258 15.5352 17.7891 15.8867C17.6094 16.3516 17.3906 16.6875 17.043 17.0352C16.6914 17.3867 16.3594 17.6016 15.8945 17.7813C15.543 17.918 15.0117 18.082 14.0391 18.125C12.9844 18.1719 12.668 18.1836 10 18.1836C7.32813 18.1836 7.01172 18.1719 5.96094 18.125C4.98438 18.082 4.45703 17.918 4.10547 17.7813C3.64063 17.6016 3.30469 17.3828 2.95703 17.0352C2.60547 16.6836 2.39063 16.3516 2.21094 15.8867C2.07422 15.5352 1.91016 15.0039 1.86719 14.0313C1.82031 12.9766 1.80859 12.6602 1.80859 9.99219C1.80859 7.32031 1.82031 7.00391 1.86719 5.95312C1.91016 4.97656 2.07422 4.44922 2.21094 4.09766C2.39063 3.63281 2.60938 3.29688 2.95703 2.94922C3.30859 2.59766 3.64063 2.38281 4.10547 2.20313C4.45703 2.06641 4.98828 1.90234 5.96094 1.85937C7.01172 1.8125 7.32813 1.80078 10 1.80078ZM10 0C7.28516 0 6.94531 0.0117187 5.87891 0.0585938C4.81641 0.105469 4.08594 0.277344 3.45313 0.523438C2.79297 0.78125 2.23438 1.12109 1.67969 1.67969C1.12109 2.23438 0.78125 2.79297 0.523438 3.44922C0.277344 4.08594 0.105469 4.8125 0.0585938 5.875C0.0117188 6.94531 0 7.28516 0 10C0 12.7148 0.0117188 13.0547 0.0585938 14.1211C0.105469 15.1836 0.277344 15.9141 0.523438 16.5469C0.78125 17.207 1.12109 17.7656 1.67969 18.3203C2.23438 18.875 2.79297 19.2188 3.44922 19.4727C4.08594 19.7188 4.8125 19.8906 5.875 19.9375C6.94141 19.9844 7.28125 19.9961 9.99609 19.9961C12.7109 19.9961 13.0508 19.9844 14.1172 19.9375C15.1797 19.8906 15.9102 19.7188 16.543 19.4727C17.1992 19.2188 17.7578 18.875 18.3125 18.3203C18.8672 17.7656 19.2109 17.207 19.4648 16.5508C19.7109 15.9141 19.8828 15.1875 19.9297 14.125C19.9766 13.0586 19.9883 12.7188 19.9883 10.0039C19.9883 7.28906 19.9766 6.94922 19.9297 5.88281C19.8828 4.82031 19.7109 4.08984 19.4648 3.45703C19.2188 2.79297 18.8789 2.23438 18.3203 1.67969C17.7656 1.125 17.207 0.78125 16.5508 0.527344C15.9141 0.28125 15.1875 0.109375 14.125 0.0625C13.0547 0.0117188 12.7148 0 10 0Z"
                      fill="#363F4D"
                    />
                    <path
                      d="M10 4.86328C7.16406 4.86328 4.86328 7.16406 4.86328 10C4.86328 12.8359 7.16406 15.1367 10 15.1367C12.8359 15.1367 15.1367 12.8359 15.1367 10C15.1367 7.16406 12.8359 4.86328 10 4.86328ZM10 13.332C8.16016 13.332 6.66797 11.8398 6.66797 10C6.66797 8.16016 8.16016 6.66797 10 6.66797C11.8398 6.66797 13.332 8.16016 13.332 10C13.332 11.8398 11.8398 13.332 10 13.332Z"
                      fill="#363F4D"
                    />
                    <path
                      d="M16.5391 4.66016C16.5391 5.32422 16 5.85938 15.3398 5.85938C14.6758 5.85938 14.1406 5.32031 14.1406 4.66016C14.1406 3.99609 14.6797 3.46094 15.3398 3.46094C16 3.46094 16.5391 4 16.5391 4.66016Z"
                      fill="#363F4D"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_158_2761">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                aria-label="facebook"
                :href="store.social?.facebook"
                v-if="store.social?.facebook"
                target="_blank"
                class="icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_158_2767)">
                    <path
                      d="M10 0C4.4772 0 0 4.4772 0 10C0 14.6896 3.2288 18.6248 7.5844 19.7056V13.056H5.5224V10H7.5844V8.6832C7.5844 5.2796 9.1248 3.702 12.4664 3.702C13.1 3.702 14.1932 3.8264 14.6404 3.9504V6.7204C14.4044 6.6956 13.9944 6.6832 13.4852 6.6832C11.8456 6.6832 11.212 7.3044 11.212 8.9192V10H14.4784L13.9172 13.056H11.212V19.9268C16.1636 19.3288 20.0004 15.1128 20.0004 10C20 4.4772 15.5228 0 10 0Z"
                      fill="#363F4D"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_158_2767">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                aria-label="snapshat"
                :href="store.social?.snapchat"
                v-if="store.social?.snapchat"
                target="_blank"
                class="icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M19.9277 14.5479C19.7898 14.17 19.5242 13.9657 19.2229 13.8023C19.1667 13.7716 19.1157 13.741 19.0697 13.7206C18.9778 13.6746 18.8858 13.6286 18.7939 13.5827C17.8542 13.0822 17.1188 12.4591 16.6131 11.7135C16.4701 11.5041 16.3425 11.2794 16.2403 11.0495C16.1944 10.927 16.1995 10.8555 16.2301 10.7891C16.2608 10.738 16.3016 10.6971 16.3527 10.6614C16.5161 10.5541 16.6795 10.4469 16.7919 10.3754C16.9911 10.2426 17.1545 10.1405 17.2567 10.069C17.6397 9.79828 17.9104 9.51228 18.0789 9.19053C18.3189 8.7411 18.3496 8.21506 18.1657 7.74009C17.9104 7.06595 17.2771 6.65227 16.5059 6.65227C16.3425 6.65227 16.1841 6.66759 16.0207 6.70334C15.9799 6.71356 15.9339 6.72377 15.893 6.73398C15.8981 6.27434 15.8879 5.78916 15.8471 5.30909C15.7041 3.62883 15.1116 2.7504 14.4988 2.05072C14.1055 1.61151 13.6459 1.23868 13.1301 0.947576C12.2006 0.416431 11.1434 0.145752 9.99427 0.145752C8.84516 0.145752 7.79309 0.416431 6.86359 0.947576C6.34776 1.23868 5.88812 1.61151 5.49487 2.05072C4.88201 2.7504 4.29469 3.63394 4.14658 5.30909C4.10572 5.78916 4.09551 6.27434 4.10061 6.73398C4.05976 6.72377 4.0189 6.71356 3.97294 6.70334C3.81461 6.66759 3.65119 6.65227 3.49286 6.65227C2.72168 6.65227 2.0884 7.07106 1.83304 7.74009C1.64918 8.21506 1.67982 8.7411 1.91986 9.19053C2.0884 9.51228 2.35907 9.79828 2.74211 10.069C2.84425 10.1405 3.00258 10.2426 3.20686 10.3754C3.31411 10.4469 3.47243 10.549 3.63076 10.6512C3.68694 10.6869 3.7329 10.7329 3.76865 10.7891C3.79929 10.8555 3.8044 10.927 3.75333 11.0597C3.65119 11.2845 3.52861 11.5041 3.38561 11.7084C2.89022 12.4336 2.17522 13.0515 1.26614 13.5469C0.78607 13.8023 0.285569 13.9708 0.0710683 14.5479C-0.0872535 14.982 0.0148896 15.4723 0.418355 15.8911C0.566463 16.0443 0.740106 16.1771 0.929071 16.2793C1.32232 16.4938 1.74111 16.6623 2.18032 16.7798C2.27225 16.8053 2.35397 16.841 2.43057 16.8921C2.57868 17.0198 2.55825 17.2139 2.75233 17.4999C2.84936 17.648 2.97704 17.7757 3.12004 17.8778C3.53372 18.1638 3.99847 18.1791 4.48876 18.1996C4.93308 18.2149 5.43358 18.2353 6.01069 18.4243C6.25073 18.5009 6.49587 18.6541 6.78187 18.8328C7.47134 19.2567 8.41106 19.8338 9.98917 19.8338C11.5673 19.8338 12.5121 19.2516 13.2067 18.8277C13.4927 18.6541 13.7378 18.5009 13.9676 18.4243C14.5396 18.2353 15.0453 18.2149 15.4896 18.1996C15.9799 18.1791 16.4446 18.1638 16.8583 17.8778C17.0319 17.7552 17.1749 17.602 17.2771 17.4182C17.4201 17.1781 17.415 17.0096 17.5478 16.8921C17.6193 16.841 17.701 16.8053 17.7827 16.7849C18.2219 16.6674 18.6509 16.4989 19.0493 16.2793C19.2484 16.172 19.4323 16.029 19.5855 15.8605L19.5906 15.8554C19.989 15.4468 20.086 14.9667 19.9277 14.5479ZM18.5283 15.2987C17.6754 15.7685 17.1034 15.7175 16.6642 16.0035C16.2863 16.2435 16.511 16.7644 16.2403 16.9534C15.9033 17.1832 14.9125 16.9381 13.6357 17.362C12.5785 17.7093 11.9095 18.7154 10.0096 18.7154C8.10973 18.7154 7.45602 17.7144 6.38351 17.362C5.10673 16.9381 4.11594 17.1883 3.77886 16.9534C3.50819 16.7644 3.72779 16.2435 3.35497 16.0035C2.91065 15.7175 2.34375 15.7685 1.49086 15.2987C0.944392 14.9974 1.25593 14.8135 1.43468 14.7267C4.52962 13.2303 5.02501 10.9167 5.04544 10.7431C5.07097 10.5337 5.10162 10.3703 4.8718 10.1609C4.65219 9.9566 3.67161 9.34885 3.39583 9.15988C2.9464 8.84324 2.74722 8.5317 2.89533 8.14356C2.99747 7.87799 3.24772 7.77584 3.50819 7.77584C3.5899 7.77584 3.67161 7.78606 3.75333 7.80138C4.24872 7.90863 4.7288 8.15377 5.00458 8.22527C5.04033 8.23549 5.07098 8.2406 5.10673 8.2406C5.25483 8.2406 5.3059 8.16399 5.29569 7.99545C5.26505 7.45409 5.18844 6.40202 5.27526 5.41634C5.39273 4.06294 5.82683 3.3888 6.34776 2.79637C6.59801 2.51037 7.76755 1.27443 10.0096 1.27443C12.2516 1.27443 13.4212 2.50526 13.6714 2.79126C14.1924 3.38369 14.6265 4.05783 14.7439 5.41123C14.8308 6.39691 14.7541 7.44899 14.7184 7.99034C14.7082 8.1691 14.7593 8.23549 14.9074 8.23549C14.9431 8.23549 14.9738 8.23038 15.0095 8.22017C15.2853 8.15377 15.7654 7.90352 16.2608 7.79627C16.3425 7.77584 16.4242 7.77074 16.5059 7.77074C16.7664 7.77074 17.0166 7.87288 17.1188 8.13845C17.2669 8.5266 17.0677 8.83813 16.6183 9.15478C16.3476 9.34374 15.367 9.95149 15.1423 10.1558C14.9125 10.3652 14.9431 10.5286 14.9686 10.738C14.9891 10.9116 15.4845 13.2252 18.5794 14.7216C18.7633 14.8084 19.0697 14.9974 18.5283 15.2987Z"
                    fill="#363F4D"
                  />
                </svg>
              </a>
              <a
                aria-label="tiwtter"
                :href="store.social?.twitter"
                v-if="store.social?.twitter"
                target="_blank"
                class="icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M15.2721 1.58667H18.0833L11.9416 8.60625L19.1668 18.1583H13.5095L9.07852 12.365L4.00845 18.1583H1.19552L7.76469 10.6501L0.833496 1.58667H6.63442L10.6397 6.88195L15.2721 1.58667ZM14.2854 16.4757H15.8432L5.78799 3.18095H4.11638L14.2854 16.4757Z"
                    fill="#363F4D"
                  />
                </svg>
              </a>
              <a
                aria-label="whatsapp"
                :href="store.social?.whatsapp"
                v-if="store.social?.whatsapp"
                target="_blank"
                class="icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    d="M11 1C5.48577 1 1 5.48577 1 11C1 12.8812 1.52269 14.7073 2.51423 16.2931C2.11923 17.6769 1.40577 20.2946 1.39808 20.3219C1.37987 20.3883 1.37991 20.4584 1.39818 20.5248C1.41646 20.5912 1.4523 20.6515 1.50192 20.6992C1.60308 20.7965 1.74923 20.8312 1.88231 20.7904L5.84615 19.5712C7.40202 20.5077 9.18402 21.0017 11 21C16.5142 21 21 16.5142 21 11C21 5.48577 16.5142 1 11 1ZM11 20.2308C9.26824 20.2325 7.57111 19.7458 6.10346 18.8265C6.05665 18.7972 6.00409 18.7784 5.94933 18.7712C5.89458 18.764 5.83893 18.7687 5.78615 18.785L2.325 19.8504C2.64479 18.6783 2.97018 17.5078 3.30115 16.3388C3.33192 16.2319 3.31462 16.1165 3.25423 16.0231C2.28271 14.5281 1.76677 12.7829 1.76923 11C1.76923 5.91038 5.91038 1.76923 11 1.76923C16.0896 1.76923 20.2308 5.91038 20.2308 11C20.2308 16.0896 16.0896 20.2308 11 20.2308Z"
                    fill="#363F4D"
                    stroke="#363F4D"
                    stroke-width="0.2"
                  />
                  <path
                    d="M16.9406 13.5963C16.2306 13.2021 15.626 12.8067 15.1849 12.5182C14.8479 12.2982 14.6045 12.1394 14.426 12.0498C13.9272 11.8009 13.5491 11.9767 13.4052 12.1221C13.3873 12.1399 13.3712 12.1595 13.3572 12.1805C12.8391 12.9578 12.1625 13.7013 11.9645 13.7413C11.7356 13.7055 10.6645 13.0967 9.59985 12.2102C8.51293 11.3044 7.82908 10.4371 7.7287 9.84631C8.426 9.12861 8.67716 8.67708 8.67716 8.16323C8.67716 7.63362 7.44177 5.42246 7.21831 5.199C6.99408 4.97515 6.48908 4.94015 5.71716 5.094C5.6428 5.10906 5.57447 5.14556 5.52062 5.199C5.42716 5.29246 3.24024 7.52208 4.27947 10.2244C5.42024 13.1902 8.34831 16.6375 12.0814 17.1975C12.5056 17.2609 12.9033 17.2925 13.2756 17.2925C15.4718 17.2925 16.7679 16.1875 17.1329 13.9955C17.1462 13.9173 17.1348 13.8368 17.1004 13.7653C17.0659 13.6938 17.0101 13.6347 16.9406 13.5963ZM12.1956 16.4367C8.24793 15.8448 5.76139 11.9336 4.99754 9.94823C4.23985 7.979 5.63716 6.22323 5.98793 5.82631C6.27331 5.77785 6.5737 5.75746 6.69908 5.77708C6.961 6.14131 7.86793 7.85477 7.90793 8.16323C7.90793 8.36515 7.84216 8.64631 7.05908 9.42977C7.0233 9.46542 6.99492 9.50781 6.97558 9.55447C6.95623 9.60114 6.94632 9.65118 6.94639 9.70169C6.94639 11.7155 11.1941 14.5094 11.9464 14.5094C12.6006 14.5094 13.4537 13.4098 13.9395 12.6932C13.9896 12.6981 14.0382 12.7133 14.0822 12.7378C14.2206 12.8075 14.4606 12.964 14.7641 13.1625C15.1649 13.4244 15.6972 13.7721 16.3256 14.1325C16.0402 15.5055 15.2425 16.8944 12.1956 16.4367Z"
                    fill="#363F4D"
                    stroke="#363F4D"
                    stroke-width="0.2"
                  />
                </svg>
              </a>
              <a
                aria-label="tiktok"
                :href="store.social?.tiktok"
                v-if="store.social?.tiktok"
                target="_blank"
                class="icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M7.62454 20C6.16868 20 4.79563 19.5355 3.65383 18.6566C3.43985 18.4918 3.23621 18.314 3.04407 18.1242C1.71126 16.807 1.04055 15.0527 1.15579 13.1844C1.2429 11.7723 1.81165 10.4109 2.75813 9.35117C4.01165 7.94766 5.73977 7.17461 7.62493 7.17461C7.94876 7.17461 8.27571 7.19883 8.59758 7.24648L9.09758 7.3207V11.7578L8.32766 11.5035C8.10401 11.4294 7.86991 11.3917 7.6343 11.3918C7.03821 11.3918 6.48001 11.6254 6.06243 12.0492C5.6468 12.4711 5.42298 13.0289 5.43157 13.6207C5.4429 14.3836 5.84485 15.075 6.50657 15.4711C6.81126 15.6531 7.15813 15.7598 7.51048 15.7793C7.7886 15.7945 8.06321 15.7582 8.32727 15.6711C9.23001 15.373 9.83665 14.5355 9.83665 13.5875L9.84055 8.98594V0H14.0812L14.0863 0.580469C14.0886 0.843359 14.1156 1.10625 14.1663 1.36094C14.3656 2.3625 14.9273 3.25508 15.748 3.87383C16.4765 4.42344 17.346 4.71367 18.2616 4.71367C18.2831 4.71367 18.2831 4.71367 18.4788 4.72734L19.0238 4.76562V8.94531L18.8284 8.94492H18.239C17.1097 8.94492 16.0515 8.72969 15.0027 8.28711C14.6902 8.15508 14.3859 8.0043 14.0921 7.83594L14.1054 13.6098C14.0984 15.3176 13.4234 16.9195 12.205 18.1238C11.2163 19.1008 9.96868 19.725 8.5968 19.9281C8.27492 19.976 7.94995 20 7.62454 20ZM7.62454 8.34648C6.07805 8.34648 4.66008 8.98047 3.63196 10.1316C2.86008 10.9961 2.39602 12.1059 2.32493 13.2562C2.23118 14.7816 2.77883 16.2145 3.86751 17.2902C4.02493 17.4457 4.19329 17.593 4.36829 17.7277C5.30344 18.4477 6.42962 18.8281 7.62454 18.8281C7.89251 18.8281 8.16165 18.8082 8.42532 18.7691C9.54915 18.6027 10.5714 18.0914 11.3816 17.2906C12.3769 16.307 12.9281 14.9996 12.9339 13.609L12.9156 5.54688L13.862 6.27695C14.3521 6.65465 14.8888 6.96764 15.4589 7.2082C16.239 7.5375 17.0253 7.72031 17.8515 7.76367V5.87109C16.8304 5.79453 15.8659 5.43164 15.0421 4.81016C13.9913 4.01797 13.2722 2.87422 13.0167 1.59023C12.9894 1.45234 12.9671 1.31289 12.9507 1.17227H11.012V8.98633L11.0081 13.5879C11.0081 15.0422 10.0784 16.3266 8.69446 16.7836C8.29094 16.9168 7.87102 16.9723 7.44602 16.9492C6.90462 16.9195 6.3718 16.7559 5.90462 16.4766C4.89173 15.8707 4.27649 14.8094 4.2593 13.6379C4.24602 12.7301 4.58938 11.8738 5.22688 11.2266C5.86633 10.5773 6.72102 10.2199 7.63352 10.2199C7.73118 10.2199 7.82805 10.2242 7.92493 10.2324V8.35469C7.82493 8.34922 7.72454 8.34648 7.62454 8.34648Z"
                    fill="#363F4D"
                  />
                </svg>
              </a>
              <a
                aria-label="youtube"
                :href="store.social?.youtube"
                v-if="store.social?.youtube"
                target="_blank"
                class="icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <g clip-path="url(#clip0_781_2654)">
                    <path
                      d="M14.3862 10.0975L9.52588 7.43819C9.24641 7.28526 8.91611 7.29098 8.64218 7.45327C8.36809 7.61573 8.20459 7.90277 8.20459 8.22134V13.4944C8.20459 13.8115 8.3671 14.098 8.63935 14.2606C8.78149 14.3455 8.9391 14.3882 9.09705 14.3882C9.24484 14.388 9.39026 14.351 9.52021 14.2806L14.3807 11.6671C14.5223 11.591 14.6407 11.4781 14.7234 11.3402C14.8061 11.2024 14.8501 11.0448 14.8507 10.8841C14.8513 10.7233 14.8085 10.5653 14.7267 10.4269C14.645 10.2884 14.5273 10.1746 14.3862 10.0975ZM9.49382 12.8311V8.89006L13.1264 10.8777L9.49382 12.8311Z"
                      fill="#363F4D"
                    />
                    <path
                      d="M21.8381 6.68279L21.8371 6.67273C21.8185 6.49566 21.633 4.9206 20.8673 4.11945C19.9822 3.17715 18.9788 3.06268 18.4963 3.00781C18.4598 3.00379 18.4234 2.99942 18.387 2.99471L18.3485 2.99071C15.4402 2.77922 11.0478 2.75034 11.0038 2.75017L11 2.75L10.9961 2.75017C10.9521 2.75034 6.55976 2.77922 3.62513 2.99071L3.58637 2.99471C3.55513 2.99892 3.52072 3.00278 3.48329 3.00717C3.0063 3.06217 2.01364 3.17685 1.12608 4.15318C0.396772 4.94578 0.185968 6.48711 0.164312 6.66031L0.16182 6.68279C0.155245 6.75648 0 8.51067 0 10.2717V11.9179C0 13.679 0.155245 15.4331 0.16182 15.507L0.16298 15.518C0.181628 15.6923 0.366909 17.2385 1.12909 18.0399C1.9613 18.9507 3.01352 19.0712 3.5795 19.136C3.66896 19.1462 3.746 19.1549 3.79851 19.1642L3.84938 19.1712C5.52868 19.331 10.7938 19.4097 11.0171 19.4129L11.0238 19.4131L11.0305 19.4129C11.0745 19.4127 15.4667 19.3839 18.3751 19.1724L18.4135 19.1684C18.4503 19.1635 18.4916 19.1591 18.5369 19.1544C19.0113 19.1041 19.9985 18.9995 20.8738 18.0364C21.6031 17.2437 21.8141 15.7023 21.8356 15.5293L21.8381 15.5068C21.8447 15.433 22.0001 13.6789 22.0001 11.9179V10.2717C21.9999 8.51063 21.8447 6.75665 21.8381 6.68279ZM20.7107 11.9179C20.7107 13.5479 20.5684 15.2265 20.5549 15.3806C20.5002 15.8051 20.2778 16.7802 19.9225 17.1665C19.3746 17.7692 18.8119 17.829 18.401 17.8724C18.3551 17.8771 18.3094 17.8823 18.2637 17.8879C15.4506 18.0913 11.224 18.1225 11.0293 18.1237C10.811 18.1205 5.62283 18.0411 3.99475 17.8899C3.9113 17.8763 3.82115 17.8659 3.72619 17.8551C3.2443 17.7999 2.58465 17.7244 2.07745 17.1665L2.0655 17.1537C1.71638 16.79 1.50038 15.8781 1.44546 15.3856C1.43524 15.2692 1.28923 13.5707 1.28923 11.9179V10.2717C1.28923 8.64361 1.43124 6.96681 1.44499 6.80954C1.5103 6.30952 1.73688 5.39343 2.07745 5.02312C2.64205 4.4021 3.23743 4.33331 3.63119 4.2878C3.66879 4.28342 3.70385 4.27942 3.73625 4.27521C6.59031 4.07077 10.8472 4.04039 11 4.03923C11.1527 4.04022 15.4081 4.07077 18.2368 4.27521C18.2715 4.2796 18.3095 4.28394 18.3502 4.28866C18.7553 4.33481 19.3674 4.40463 19.9292 5.00383L19.9344 5.00937C20.2835 5.3731 20.4995 6.30097 20.5544 6.80331C20.5642 6.91327 20.7107 8.61538 20.7107 10.2717V11.9179Z"
                      fill="#363F4D"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_781_2654">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="all-links">
          <div class="links-container">
            <h4>{{ $t("impLinks") }}</h4>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="3"
              viewBox="0 0 50 3"
              fill="none"
            >
              <rect
                x="11.9043"
                width="38.0952"
                height="3.00022"
                rx="1.50011"
                fill="#00A0B4"
              />
              <rect
                opacity="0.9"
                width="7.14286"
                height="3.00022"
                rx="1.50011"
                fill="#00A0B4"
              />
            </svg>
            <div class="links">
              <nuxt-link :to="localePath('/jobs')" class="link">
                {{ $t("employ") }}
              </nuxt-link>
              <nuxt-link :to="localePath('/contact')" class="link">
                {{ $t("contact") }}
              </nuxt-link>
              <nuxt-link :to="localePath('/terms')" class="link">
                {{ $t("policy") }}
              </nuxt-link>
              <nuxt-link :to="localePath('/policy')" class="link">
                {{ $t("policy2") }}
              </nuxt-link>
              <span @click="openPopup = !openPopup" class="link">
                {{ $t("reqOrd") }}</span
              >
            </div>
          </div>
          <div class="links-container">
            <h4>{{ $t("branches") }}</h4>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="3"
              viewBox="0 0 50 3"
              fill="none"
            >
              <rect
                x="11.9043"
                width="38.0952"
                height="3.00022"
                rx="1.50011"
                fill="#00A0B4"
              />
              <rect
                opacity="0.9"
                width="7.14286"
                height="3.00022"
                rx="1.50011"
                fill="#00A0B4"
              />
            </svg>
            <div class="links">
              <span
                class="link"
                v-for="item in store.branches.slice(0, 4)"
                :key="item"
                @click="(openPopup2 = true), branch = item , (frameDiv = item.frame)"
              >
                {{ item.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="subscripe-container">
          <h3>{{ $t("subscripe") }}</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="3"
            viewBox="0 0 50 3"
            fill="none"
          >
            <rect
              x="11.9043"
              width="38.0952"
              height="3.00022"
              rx="1.50011"
              fill="#00A0B4"
            />
            <rect
              opacity="0.9"
              width="7.14286"
              height="3.00022"
              rx="1.50011"
              fill="#00A0B4"
            />
          </svg>
          <p>{{ $t("subscripe") }}</p>
          <div class="search-input">
            <div class="inputt">
              <input
                type="email"
                v-model="subscripe"
                :placeholder="$t('enterEmail')"
              />
            </div>
            <button @click="subFunc()" class="">
              <div class="d-flex align-items-center gap-2">
                <span> {{ $t("join") }} </span>
              </div>
            </button>
          </div>
          <span v-if="store.errorSub" class="text-danger">
            {{ store.errorSub?.email[0] }}
          </span>
        </div>
      </div>
      <div class="foot-line">
        <span> © {{ $t("foot") }}</span>
        <a
          aria-label="webstdy"
          href="https://webstdy.com/ar?utm_source=khalej-footer&utm_medium=referral"
          target="_blank"
          class="d-flex align-items-center gap-3"
        >
          <span> {{ $t("devBy") }} </span>
          <img :src="imgURL" width="45" height="45" alt="webstdy" />
        </a>
      </div>
      <div v-if="openPopup2" class="popup-container">
        <div class="overlay"></div>
        <div class="modal-custom-container">
        <div class="d-flex w-100 flex-column ">
        <div>
        <h5 class="m-0 mb-2"> {{ $t('mainAddress') }} </h5>
        <p class="w-100 mt-0"> {{ branch?.address }} </p>
        </div>
          <div class="row mt-4 px-3 w-100 p-0 m-0 gap-3 gap-xl-0 gap-lg-0">
            <div class="col-12 col-xl-6 col-lg-6  p-0 m-0">
              <div class="  d-flex flex-column gap-4 align-items-center align-items-xl-start align-items-lg-start ">
                <div class="d-flex align-items-center gap-2">
                  <span> {{ $t('branchName') }} : </span>
                  <h6 class="fw-bold "> {{ branch?.name }} </h6>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <span> {{ $t('city') }} : </span>
                  <h6 class="fw-bold "> {{ branch?.city?.title }} </h6>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <span> {{ $t('branchNum') }} : </span>
                  <h6 class="fw-bold "> {{ branch?.phone }} </h6>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <span> {{ $t('whatsapp') }} : </span>
                  <h6 class="fw-bold "> {{ branch?.whatsapp }} </h6>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-6 col-lg-6 p-0 m-0" v-html="frameDiv"></div>
          </div>
        </div>
          <button @click="openPopup2 = false" class="close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L8 6.58579L13.2929 1.29289C13.6834 0.902369 14.3166 0.902369 14.7071 1.29289C15.0976 1.68342 15.0976 2.31658 14.7071 2.70711L9.41421 8L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L8 9.41421L2.70711 14.7071C2.31658 15.0976 1.68342 15.0976 1.29289 14.7071C0.902369 14.3166 0.902369 13.6834 1.29289 13.2929L6.58579 8L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289Z"
                fill="#A7B9D0"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <popup-one :openPopup="openPopup" @update="handleUpdatePopup"></popup-one>
  </div>
</template>

<script setup>
const localePath = useLocalePath();
const { locale, setLocale } = useI18n();
import { useHomeStore } from "@/stores/home";
let store = useHomeStore();
let frameDiv = ref();
let branch = ref();
store.getBranches();
store.getSocial();
let openPopup = ref(false);
let openPopup2 = ref(false);
let subscripe = ref("");
function isValidEmail() {
  if (subscripe.value != "") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(subscripe.value);
  }
}
let error = ref();
const subFunc = () => {
  if (isValidEmail()) {
    store.subscriber(subscripe.value);
  }
};
watch(
  () => store.pendingSub,
  (val) => {
    if (val) {
      subscripe.value = "";
    }
  }
);
const imgURL = "https://webstdy.com/CDN/cr_blue.png";
const handleUpdatePopup = (newState) => {
  openPopup.value = newState;
};
</script>
